import { render, staticRenderFns } from "./inventoryFilterdata.vue?vue&type=template&id=0427d238&scoped=true"
import script from "./inventoryFilterdata.vue?vue&type=script&lang=js"
export * from "./inventoryFilterdata.vue?vue&type=script&lang=js"
import style0 from "./inventoryFilterdata.vue?vue&type=style&index=0&id=0427d238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0427d238",
  null
  
)

export default component.exports